<template>
  <main class="mt-5">
    <span id="add-btn">
      <router-link :disabled="hasPermission('write_post') ? false : true" to="/admin/posts/create"
        class="btn btn-success">مطلب جدید</router-link>
    </span>
    <b-tooltip v-if="!hasPermission('write_post')" target="add-btn" triggers="hover">
      شما به این بخش دسترسی ندارید
    </b-tooltip>

    <div class="card mt-3">
      <div class="card-header  border-0">
        <h5 class="card-title font-bold"> مطالب</h5>
        <div style="flex:1"></div>
        <b-button v-b-toggle.filter :variant="hasFilter() ? 'secondary' : 'primary'">
          <span class="fe fe-search pt-1" style="font-size: 17px;"></span>
        </b-button>
      </div>
      <b-collapse id="filter" class="mt-2 mx-5">
        <b-card>
          <form @submit.prevent="filterItem()">
            <div class="row mt-5">
              <b-form-group class="col-md-4">
                <b-form-input :disabled="disabled" placeholder="عنوان مطلب" v-model="filter.title">
                </b-form-input>
              </b-form-group>
              <b-form-group v-if="widgetData.postCategories" class="col-md-4">
                <multiselect placeholder="دسته بندی" v-model="filter.post_category_id" open-direction="bottom"
                  :options="widgetData.postCategories" label="name" track-by="id" :searchable="true"
                  :close-on-select="true" :show-labels="false" :disabled="disabled">
                  <template slot="noOptions">
                    موردی یافت نشد
                  </template>
                  <template slot="noResult">
                    موردی یافت نشد
                  </template>
                </multiselect>
              </b-form-group>
              <b-form-group class="col-md-4">
                <multiselect placeholder="وضعیت" v-model="filter.status" open-direction="bottom"
                  :options="status_options" label="name" track-by="value" :searchable="true" :close-on-select="true"
                  :show-labels="false" :disabled="disabled">
                  <template slot="noOptions">
                    موردی یافت نشد
                  </template>
                  <template slot="noResult">
                    موردی یافت نشد
                  </template>
                </multiselect>
              </b-form-group>
            </div>
            <div class="text-center mt-3">
              <button :disabled="disabled" type="submit" class="btn btn-primary px-5">جستجو</button>
              <button :disabled="disabled" @click="resetFilter" class="btn btn-warning px-5 mr-3">برداشتن
                فیلتر</button>
              <button :disabled="disabled" @click="$root.$emit('bv::toggle::collapse', 'filter')"
                class="btn btn-secondary px-5 mr-3">بستن</button>
            </div>
          </form>
        </b-card>
      </b-collapse>
      <div class="card-body">
        <div>
          <b-table responsive hover bordered :items="items.data" :fields="fields">
            <template v-slot:cell(status)="data">
              <span v-if="data.item.status == 'draft' " class="badge badge-info status">پیش نویس</span>
              <span v-else-if="data.item.status == 'pending' " class="badge badge-warning status">در
                انتظار بررسی</span>
              <span v-else-if="data.item.status == 'unpublished' " class="badge badge-danger status">انتشار
                نیافته</span>
              <span v-else-if="data.item.status == 'published' " class="badge badge-success status">انتشار
                یافته</span>
            </template>
            <template v-slot:cell(category)="data">
              {{ data.item.category ? data.item.category.name : ''}}
            </template>
            <template v-slot:cell(created_at)="data">
              {{ data.item.created_at | persianDate}}
            </template>
            <template v-slot:cell(edit)="data">
              <span :id="'edit-btn-' + data.item.id">
                <router-link :disabled="!hasPermission('modify_post') ? true : false " :to="{name:'post.edit' , params:{ id: data.item.id}}" class="action-btns1  pt-1 px-2">
                  <i class="feather feather-edit  text-primary"></i>
                </router-link>
              </span>
              <b-tooltip v-if="!hasPermission('modify_post')" :target="'edit-btn-' + data.item.id" triggers="hover">
                شما به این بخش دسترسی ندارید
              </b-tooltip>
            </template>
            <template v-slot:cell(comments)="data">
              <span :id="'comment-btn-' + data.item.id">
                 <router-link :to="{name:'post.comment' , params:{ post: data.item.id}}" 
                class="action-btns1  pt-1 px-2  position-relative"
              >
                <i class="fe fe-message-square text-warning"></i>
                  <span class="answer-count bg-warning text-white">{{data.item.comments.length}}</span>
              </router-link>
              </span>
              <!-- <b-tooltip v-if="!hasPermission('read_post_comment')" :target="'comment-btn-' + data.item.id" triggers="hover">
                شما به این بخش دسترسی ندارید
              </b-tooltip> -->
            </template>
            <template v-slot:cell(delete)="data">
              <span :id="'delete-btn-' + data.item.id">
                <a :disabled="!hasPermission('delete_post') ? true : false " class="action-btns1  pt-1 px-2 " @click="deleteItem(data.item.id)">
                  <i class="feather feather-trash-2 text-danger"></i>
                </a>
              </span>
              <b-tooltip v-if="!hasPermission('delete_post')" :target="'delete-btn-' + data.item.id" triggers="hover">
                شما به این بخش دسترسی ندارید
              </b-tooltip>
            </template>
          </b-table>
          <Loading v-if="$root.isEmptyObject(items)" />
          <pagination v-else-if="items.data != ''" :disabled="disabled" :limit="2" :data="items"
            @pagination-change-page="changePage">
          </pagination>
          <div v-else class="alert alert-danger">
            موردی یافت نشد
          </div>
        </div>
      </div>
    </div>

  </main>
</template>
<script>
import PostImpl from '@@/core/pages/post/Post/PostImpl'
export default {
  extends: PostImpl
}
</script>

<style scoped src="@@/core/pages/post/Post/PostStyle.css"></style>